import React from "react";
import imghero from "../../../../assets/home/banner-u.png";
import "./header.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const header = () => {
  const waabout = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send?phone=62895417144022&text=Halo%20Sandy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20()%20(https://marketing-grandwisatabekasi.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="header">
      <div className="container-content-header">
        <div className="content-header">
          <div className="heading1">
            <h2>Sinarmas Land - Grand Wisata</h2>
          </div>
          <div className="heading2">
            <h1>Live, Play and Work in One Area</h1>
          </div>
          <div className="deskripsi">
            <p>
              Menciptakan keseimbangan antara kehidupan pribadi, sosial, dan
              profesional, memungkinkan penduduk untuk menghindari keterlambatan
              dan kelelahan yang disebabkan oleh perjalanan jauh.
            </p>
          </div>
          <div className="button">
            <button onClick={waabout} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Hubungi Kami
            </button>
          </div>
        </div>
        <div className="content-image">
          <img src={imghero} alt="banner-grandwisata" />
          <div className="content-hook">
            <div className="hook">
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>DP 0%</span>
              </div>
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Discount Up To 15%</span>
              </div>
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Free PPN</span>
              </div>
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Early Bird Disc. Up To 10 Juta</span>
              </div>
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Free Biaya-Biaya</span>
              </div>
            </div>
            <div className="hook">
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Full Smarthome System</span>
              </div>
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Full Smartdoor Lock</span>
              </div>
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Free Canopy</span>
              </div>
              <div className="hook-item">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="icon"
                  color="#467FF7"
                />
                <span>Free CCTV</span>
              </div>
            </div>
          </div>
          <small>*T&C Apply</small>
        </div>
      </div>
    </div>
  );
};

export default header;
